import {
  cities as allCities,
  searchCities
} from 'vibemap-constants/dist/helpers.js'

async function callAPI(endpoint) {
  try {
    const response = await fetch(endpoint)
    const json = await response.json()
    return json
  } catch (error) {
    console.error(error)
  }
}

export const getEvents = async (options, apiURL) => {
  const centerPoint = options?.point

  const searchParams = {
    category: options.category || '',
    ordering: '-aggregate_rating',
    per_page: options.perPage || 50,
    dist: options.distance > 0 ? options.distance * 1609.344 : 1,
    point: centerPoint,
    days: options.days || '',
    search: options.search || '',
    time: options.time || '',
    vibes: options.vibes || '',
    zoom: options.zoom || '',
  }

  const searchQuery = new URLSearchParams(searchParams).toString()

  const apiResult = await callAPI(`${apiURL}/events/?${searchQuery}`)

  return apiResult?.results?.features || []
}

export const getCities = async (options, apiURL) => {

  const searchParams = {
    search: options.search,
  }
  const searchQuery = new URLSearchParams(searchParams).toString()

  const cityData = await searchCities(searchQuery)
  const newCities = cityData?.filter(newCity => {
    const foundExisting = allCities.find(city => city.slug == newCity.slug)
    const isNew = foundExisting == null || foundExisting == undefined
    return isNew
  })

  // TODO: use Mapbox until all boundaries are in PostGIS/GeoJSON
  //const apiResult = await callAPI(`${apiURL}/boundaries/?${searchQuery}`)
  // return apiResult?.results || []

  return newCities
}

export const getGuides = async (options, apiURL) => {
  const joinedFields = options.fields
    ? options.fields.join(',')
    : 'id,content,featured_media,featured_media_src_url,link,title'

  const searchParams = {
    search: options.search,
    per_page: options.perPage || 20,
    cities: options.cities || '',
    _fields: joinedFields,
  }

  const searchQuery = new URLSearchParams(searchParams).toString()
  const apiResult = await callAPI(`${apiURL}/posts?${searchQuery}`)
  return apiResult
}